// @ts-ignore
import HighlandJS from 'highland/dist/highland';
import type HighlandType from 'highland';

export const Highland = HighlandJS as typeof HighlandType;
